import React from 'react';

import './Frame.css';

export function Error() {
    return (
       <div>
        Error
       </div>
    )
}
